export class NameValueString {
  public name: string;
  public value: string;

  public constructor(itemName?: string, itemValue?: string) {
    if (itemName == null || itemName == undefined) {
      this.name = '';
    } else {
      this.name = itemName;
    }
    if (itemValue == null || itemValue == undefined) {
      this.value = '';
    } else {
      this.value = itemValue;
    }
  }
}
